export default __webpack_public_path__ + "static/media/ThrowDisc.ad7f2d48.ogg";